import {
    Button,
    Container,
    Form,
    FormGroup,
    Input,
    Segment,
    SegmentContent,
    SegmentHeader,
    Toggle,
} from '@/platform/ui';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { Link, useForm, usePage } from '@inertiajs/react';
import { useEffect } from 'react';

const WebhookCreateOrUpdateView = () => {
    const { webhook } = usePage().props;
    const { data, setData, post, patch, errors, processing } = useForm({});

    useEffect(() => {
        setData(webhook || {});
    }, [webhook]);

    const handleSubmit = () => {
        if (webhook?.id) {
            patch(`/datahub-webhooks/${webhook.id}`);

            return;
        }

        post('/datahub-webhooks');
    };

    return (
        <Container>
            <Form onSubmit={handleSubmit}>
                <Segment>
                    <SegmentHeader
                        header={`Webhook ${webhook?.id ? 'bijwerken' : 'aanmaken'}`}
                    >
                        <Button as={Link} href='/datahub-webhooks'>
                            <ArrowLeftIcon className='size-5' />
                            Terug
                        </Button>
                    </SegmentHeader>

                    <SegmentContent>
                        <FormGroup>
                            <Input
                                label='Event'
                                required
                                value={data?.event || ''}
                                onChange={event =>
                                    setData('event', event.target.value)
                                }
                                error={errors?.event}
                            />
                            <Input
                                label='URL'
                                required
                                value={data?.url || ''}
                                onChange={event =>
                                    setData('url', event.target.value)
                                }
                                error={errors?.url}
                            />
                            <Input
                                label='Include'
                                value={data?.include || ''}
                                onChange={event =>
                                    setData('include', event.target.value)
                                }
                                error={errors?.include}
                            />
                            <Input
                                label='Fields Filtering'
                                value={data?.fields || ''}
                                onChange={event =>
                                    setData('fields', event.target.value)
                                }
                                error={errors?.fields}
                            />
                            <Toggle
                                label='Active'
                                checked={Boolean(data?.active || false)}
                                onChange={checked =>
                                    setData('active', checked ? 1 : 0)
                                }
                                error={errors?.active}
                            />
                        </FormGroup>
                    </SegmentContent>
                </Segment>

                <Segment floating>
                    <SegmentContent right>
                        <Button
                            type='submit'
                            variant='primary'
                            loading={processing}
                        >
                            Opslaan
                        </Button>
                    </SegmentContent>
                </Segment>
            </Form>
        </Container>
    );
};

export default WebhookCreateOrUpdateView;
